<template>
  <select class="form-control" v-model="value" v-on:change="onInput" v-if="prefectures.length">
    <option value="">都道府県を選択してください。</option>
    <option v-for="prefecture in prefectures"
            :value="prefecture.prefecture_id">
      {{prefecture.prefecture_name_full}}
    </option>
  </select>
</template>
<script>
  import Api from '@/service/Api.vue'

  export default {
    props: [
      'val'
    ],
    data () {
      return {
        prefectures: [],
        value: this.val
      }
    },
    watch: {
      'val': function (to, from) {
        this.value = to
      }
    },
    created: function () {
      this.initPrefecture()
    },
    methods: {
      initPrefecture: function () {
        Api.prefecture.list({}).then(this.successPrefecture)
      },
      successPrefecture: function (result) {
        this.prefectures = result.data.prefectures
        this.value = this.val
      },
      onInput (e) {
        var id = e.target.value
        var prefectureName = ''
        this.prefectures.forEach(function (val) {
          if (val.prefecture_id === Number(id)) {
            prefectureName = val.prefecture_name_full
          }
        })

        this.$emit('display', prefectureName)
        this.$emit('input', e.target.value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectPrefecture.vue?0cd61344